<template>
  <div style="margin-top: 12px;" v-loading="exportLoading" v-if="!isDetail">
    <div class="biaodan2">
      <div class="biaodan-left">
        <div style="height: 100%; width: 100%">
          <el-form
            :inline="true"
            label-position="left"
            class="demo-form-inline"
            :model="form"
          >
            <el-form-item label="值班日期">
              <el-date-picker
                v-model="form.zhibanDay"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择值班日期"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开始值班时间">
              <el-date-picker
                v-model="form.likeLogTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择开始值班时间"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束值班时间">
              <el-date-picker
                v-model="form.endLikeLogTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束值班时间"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="值班人员姓名">
              <el-input
                v-model="form.username"
                clearable
                placeholder="请输入值班人员姓名"
              ></el-input>
            </el-form-item>

            <el-form-item class="form-item">
              <el-button @click="onSearch" class="search">查询</el-button>
              <el-button class="reset" @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="aside">
      <div class="table-top-btns">
        <div class="left-btn"></div>
        <div class="right-btn">
          <el-button
            @click="userLocationLineExpFun"
            icon="el-icon-download"
            class="search"
            >导出</el-button
          >
        </div>
      </div>
      <common-table
        :select="false"
        :page="page"
        :dataList="dataList"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :maxHeight="640"
      >
        <template v-slot:zhibanList="{ scope }">
          <span>{{
            scope.row.zhibanList ? scope.row.zhibanList.toString() : ""
          }}</span>
        </template>
        <template v-slot:operation="{ scope }">
          <el-button
            @click="detailFun(scope.row)"
            style="color: #0090FF;font-size: 16px;"
            type="text"
            >详情</el-button
          >
        </template>
      </common-table>
    </div>
  </div>
  <detail @clickBackList="isDetail = false" :curItem="curItem" v-else></detail>
</template>
<script>
import { dutyLogjoinPage, dutyLogExp } from "@/api/onDutyAndStandBy.js";
import commonTable from "@/components/table/index.vue";
import detail from "./detail.vue";
import moment from "moment";
export default {
  components: {
    commonTable,
    detail
  },
  data() {
    return {
      form: {
        username: "",
        zhibanDay: "",
        likeLogTime: "",
        endLikeLogTime: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "username",
            label: "值班人员姓名"
          },

          {
            slot: "zhibanList",
            label: "值班日期"
          },
          {
            prop: "logTime",
            label: "开始值班时间"
          },
          {
            prop: "startDeviceNormalFlag",
            label: "设备是否正常"
          },
          {
            prop: "endLogTime",
            label: "结束值班时间"
          },
          {
            prop: "endDeviceNormalFlag",
            label: "设备是否正常"
          },
          {
            prop: "computeHour",
            label: "值班时长"
          },
          {
            slot: "operation",
            label: "操作",
            width: 120
          }
        ]
      },

      exportLoading: false,
      isDetail: false,
      curItem: {}
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
  },
  methods: {
    detailFun(item) {
      this.isDetail = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.username = "";
      this.form.zhibanDay = "";
      this.form.likeLogTime = "";
      this.form.endLikeLogTime = "";
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    async userLocationLineExpFun() {
      this.exportLoading = true;
      let res = await dutyLogExp({
        ...this.form,
        fillZhibanFlag: true,
        logType: "上下班打卡",
        sourceMangerId: 'ZHIBAN'
      });
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "值班记录" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        zhibanDay: this.form.zhibanDay
          ? moment(this.form.zhibanDay).format("YYYY-MM-DD")
          : "",
        likeLogTime: this.form.likeLogTime
          ? moment(this.form.likeLogTime).format("YYYY-MM-DD")
          : "",
        endLikeLogTime: this.form.endLikeLogTime
          ? moment(this.form.endLikeLogTime).format("YYYY-MM-DD")
          : "",
        fillZhibanFlag: true,
        logType: "上下班打卡",
        ghEventTypeId: "id_zhiban",
        page: this.page.page,
        size: this.page.size,
        sourceMangerId: 'ZHIBAN'
      };
      const res = await dutyLogjoinPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData =
          res.data.data && res.data.data.records ? res.data.data.records : [];
        this.page.total =
          res.data.data && res.data.data.total ? res.data.data.total : 0;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}
.table-top-btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .left-btn {
    display: flex;
    align-items: center;
    .select-number {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #3d4042;
      margin-right: 22px;
    }
    /deep/.el-button {
      padding: 0;
      height: auto;
      color: #0495ff;
    }
    /deep/.delbtn.el-button {
      padding: 0;
      height: auto;
      color: #eb3538;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onDuty/list.vue